/**
 * Created by zoechodosh on 5/12/17.
 */
export const REQUEST_MODULE_GROUP = 'zola/module-group/REQUEST_MODULE_GROUP';
export const RECEIVE_MODULE_GROUP = 'zola/module-group/RECEIVE_MODULE_GROUP';
